//window._ = require("lodash");
window.$ = require("jquery");
window.jQuery = require("jquery");
require('jquery-confirm');
require("jquery-mask-plugin");
require("jquery-maskmoney/dist/jquery.maskMoney.min");
require("gasparesganga-jquery-loading-overlay");
require("lightslider");
